module.exports = __webpack_public_path__ + "static/img/langfangwei.5d584bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/langfangwei.png
// module id = z6M2
// module chunks = 1